<template xmlns="http://www.w3.org/1999/html">
  <div class="shengsheng-page">
    <!-- 顶部整宽的酒图片 -->
    <img class="jiu-img" src="/static/images/shengsheng/jiu.png" alt="酒背景">

    <!-- Join页面内容 -->
    <!-- 蒙版层 -->
    <div class="overlay"></div>

    <!-- 居中展示的yinying.png -->
    <img class="yinying-img" src="/static/images/shengsheng/yinying.png" alt="阴影">

    <!-- 阴影框上方的jjf.png -->
    <img v-if="showPoints" class="jjf-img" :src="pointsClaimed ? '/static/images/shengsheng/yjf.png' : '/static/images/shengsheng/jjf.png'" alt="JJF">

    <!-- 积分文字和图片容器 -->
    <div v-if="showPoints" class="points-container">
      <!-- 积分文字 -->
      <div class="points-text">
        <div v-if="!pointsClaimed" class="congrats-text">恭喜获得</div>
        <div v-if="!pointsClaimed" class="points-number">{{ points }}积分</div>
        <div v-if="pointsClaimed" class="points-number">积分已领取</div>
      </div>

      <!-- 积分文字下方的lqjf.png -->
      <wx-open-launch-weapp
        id="launch-btn" 
        class="lqjf-img"
        :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage"> 
        <script type="text/wxtag-template"> 
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/jrsc-be9316d3e9a74e9663ebe1da5ad18c4f.png" 
          style="width: 100%;height: auto;display: block;" /> 
        </script> 
      </wx-open-launch-weapp>

      <!-- lqjf.png下方的rule.png -->
      <img class="rule-img" src="/static/images/shengsheng/rule.png" alt="Rule" @click="goToRule">
    </div>

    <!-- 底部三个图标 -->
    <div class="icons-container">
      <img class="icon-img" src="/static/images/shengsheng/pss.png" alt="PSS">
      <img class="icon-img" src="/static/images/shengsheng/logo.png" alt="Logo">
      <img class="icon-img" src="/static/images/shengsheng/srs.png" alt="SRS">
    </div>
  </div>
</template>

<style scoped>
.shengsheng-page {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  /* 用 bg.png 做全屏背景 */
  background: url("/static/images/shengsheng/bg.png") no-repeat center top;
  background-size: cover;
  overflow: hidden;
}

.jiu-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  display: block;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(184, 134, 81, 0.7);
  z-index: 9;
}

.yinying-img {
  position: fixed;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 75vh;
  z-index: 10;
}

.jjf-img {
  position: fixed;
  top: calc(60% - 28vh);
  /* 阴影框顶部(60%) - 阴影框高度的一半(30vh) + 2vh */
  left: 50%;
  transform: translateX(-50%);
  width: 45vw;
  height: auto;
  z-index: 11;
}

.points-container {
  position: fixed;
  top: calc(60% - 2vh);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 11;
}

.points-text {
  text-align: center;
  color: rgb(111, 45, 1);
  width: 80vw;
  white-space: nowrap;
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 4vh;
}

.congrats-text {
  font-size: 14px;
  margin-right: 5px;
  font-weight: bold;
}

.points-number {
  font-size: 26px;
  font-weight: bold;
}

.lqjf-img {
  width: 50vw;
  height: auto;
}

.rule-img {
  width: 12vw;
  height: auto;
  margin-top: 2vh;
}

.icons-container {
  position: fixed;
  top: calc(60% + 25vh);
  /* 阴影框顶部(60%) + 阴影框高度的一半(30vh) - 5vh */
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  width: 60vw;
  z-index: 11;
}

.icon-img {
  width: 16vw;
  height: 16vw;
  object-fit: contain;
  z-index: 12;
}
</style>

<script>
import { getScoreConfig, getTemplate, registerByOpenId, joinActivity, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      antiCode: '', // 防伪码
      authCode: '', // 微信授权码
      deptId: '', // 部门ID
      eno: '', // 企业号
      activityId: 0, // 活动ID
      shopUrl: '', // 商城URL
      miniAppId: '', // 小程序AppID
      miniAppOriginalId: '', // 小程序原始ID
      miniAppPage: '', // 小程序页面路径
      showPoints: false, // 控制积分相关元素的显示
      userToken: '', // 用户令牌
      points: 0, // 积分值
      pointsClaimed: false // 积分是否已领取
    };
  },
  mounted() {
    // 获取URL参数
    this.antiCode = this.$route.query.c || '';
    this.authCode = this.$route.query.wyAuthCode || '';
    this.deptId = this.$route.query.deptId || '';
    this.eno = this.$route.query.eno || '';

    // 检查参数是否为空
    if (!this.antiCode || !this.authCode || !this.deptId || !this.eno) {
      alert("请从正确入口进入");
      this.$router.push('/ssheng/index');
      return;
    }

    // 调用方法获取配置信息
    this.initPage();
    
    // 获取微信JSSDK
    this.getWxJs();
  },
  methods: {
    async initPage() {
      await this.getScoreConfig();
      await this.getTemplate();
    },
    async getScoreConfig() {
      try {
        const res = await getScoreConfig(this.deptId);
        if (res.data.data != null) {
          this.shopUrl = res.data.data.shopUrl;
          const data = this.shopUrl.split('|');
          this.miniAppId = data[0];
          this.miniAppOriginalId = data[1];
          this.miniAppPage = data[2];
        }
      } catch (error) {
        console.error('获取积分配置失败:', error);
      }
    },
    async getTemplate() {
      try {
        const res = await getTemplate(this.deptId);
        if (res.data.data != null) {
          this.activityId = res.data.data.activityId;

          // 如果activityId有值，调用registerByOpenId
          if (this.activityId) {
            await this.registerUser();
          }
        } else {
          alert("活动未开始或已下线，敬请留意最新活动信息");
        }
      } catch (error) {
        console.error('获取模板失败:', error);
        alert("活动未开始或已下线，敬请留意最新活动信息");
      }
    },
    // registerByOpenId implementation
    async registerUser() {
      try {
        const res = await registerByOpenId(this.eno, this.authCode);
        if (res.data.code === "200") {
          console.log('用户注册成功:', res.data.data);
          this.userToken = res.data.data.token;

          // 调用joinActivity
          await this.joinActivity();
        } else {
          alert("用户注册失败: " + (res.data.message || "未知错误"));
        }
      } catch (error) {
        console.error('注册用户失败:', error);
        alert("注册用户失败，请重试");
      }
    },
    // joinActivity implementation
    async joinActivity() {
      try {
        const data = {
          code: this.antiCode,
          activityId: this.activityId,
          authCode: this.authCode,
          userToken: this.userToken
        };

        const result = await joinActivity(data);
                 if (result.data.code === "200") {
                   console.log('参与活动成功:', result.data.data);
                   // 显示积分相关UI
                   this.showPoints = true;
                   // 设置积分值，去除小数点
                   this.points = result.data.data.giftValue;
                 } else if (result.data.code === "500001") {
                   console.log('积分已领取');
                   // 显示积分已领取的UI
                   this.showPoints = true;
                   // 可以在这里添加积分已领取的特殊处理逻辑
                   this.handlePointsAlreadyClaimed();
                 } else {
                   alert("参与活动失败，请联系客服处理");
                 }
      } catch (error) {
        console.error('参与活动失败:', error);
        alert("参与活动失败，请联系客服处理");
      }
    },
            // 处理积分已领取的情况
            handlePointsAlreadyClaimed() {
              // 这里可以添加积分已领取的特殊处理逻辑
              console.log('处理积分已领取的情况');
              // 可以设置一个标志，表示积分已领取
              this.pointsClaimed = true;
              // 可以显示一个提示，告知用户积分已领取
              // 也可以跳转到其他页面或显示特定内容
            },
    goToRule() {
      this.$router.push({
        path: '/ssheng/rule',
        query: {
          deptId: this.deptId
        }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    // 获取微信JSSDK配置
     async getWxJs() {
       const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx099133a5b38815d5").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ShengSheng/Join.vue